export const SELECTED_PROPERTY_UUID_KEY = 'selectedPropertyUuid';
export const FORGOT_PASSWORD_EMAIL_KEY = 'forgotPasswordEmail';
